import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { NotSignedIn } from './api/client.js';
import { ReleaseUpdateGuard } from './release.jsx';
import { AppRoutes } from './routes/index.jsx';
import './styles.css';

/**
 * The console keeps its data fresh through the live stream, not through polling: queries are
 * allowed to go stale slowly, and a lost session is never retried — it is a redirect to Security.
 */
const client = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => !(error instanceof NotSignedIn) && failureCount < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <ReleaseUpdateGuard />
    </QueryClientProvider>
  </StrictMode>,
);
